<template>
    <div class="scratch">
        <Header></Header>
        <iframe id="myiframe" :src="ifreamSrc" scrolling="no" width="100%" @load="changeFrameHeight" frameborder="0"></iframe>
    </div>
</template>
<script>
import Header from '@/components/header';
import userApi from '@/request/api/user';

export default {
    components: { Header },
    computed: {
        themeData() {
            return this.$store.state.themeData;
        }
    },
    data() {
        return {
            hostName: location.hostname,
            contentWindow: null,
            ifreamSrc: ""
        }
    },
    created() {
        window.deleteuserinfo = this.deleteuserinfo;
        if(this.$route.query && this.$route.query.lessonId) {
            this.ifreamSrc = `https://${this.hostName}/scratch?lessonId=${this.$route.query.lessonId}&class=true&pvw=true`;
        } else if(this.$route.query && this.$route.query.id) {
            this.ifreamSrc = `https://${this.hostName}/scratch?worksId=${this.$route.query.id}`;
        } else {
            this.ifreamSrc = `https://${this.hostName}/scratch`;
        }
    },
    mounted() {
        window.onresize = () => {
            this.changeFrameHeight()
        };
    },
    beforeRouteLeave (to, from, next) {
        this.$confirm('离开页面会导致未保存的程序丢失，确定离开?', '提示', {
            confirmButtonText: '离开',
            cancelButtonText: '等一下，去保存',
            type: 'warning',
            closeOnClickModal: false,
            showClose: false
        }).then(() => {
            next();
        }).catch(() => {
                  
        });
    },
    beforeDestroy() {
        window.onresize = "";
    },
    methods: {
        // 高度变化
        changeFrameHeight() {
            var frm = document.getElementById('myiframe');
            frm.height = document.documentElement.clientHeight;
            this.setScratchStatus();
        },
        //初始化contentWindow
        setScratchStatus() {
            this.contentWindow = document.getElementById('myiframe').contentWindow;
            this.$store.commit('setScratchLogin', this.contentWindow.getCurrentUserFN);
            this.$store.commit('setScratchLogout', this.contentWindow.currentLogOut);
        },
        deleteuserinfo() {
            userApi.deleteToken();
            this.$store.commit('setUserInfo', null)
            this.$store.commit('setLoginBtnShow', true)
            this.$store.commit('setDialogVisible', true)
        }
    },
}
</script>
<style lang="scss">
.scratch {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
}
#myiframe {
    height: calc(100vh - 51px);
    min-width: 1024px;
    min-height: 640px;
}
</style>


// WEBPACK FOOTER //
// src/views/scratch/scratch.vue